<template>
  <FilterBadge v-bind="$attrs" :filter="filter" icon="fas fa-hashtag"> {{ text }} </FilterBadge>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import IDFilter from "../../filterImplementations/IDFilter";
import FilterBadge from "./FilterBadge.vue";
import { BoardFilterOptionsInjectionKey, FilterBadgeProps, FilterEntity } from "../../FilterTypes";
import { useSQDCDisplayName } from "../../../../../helper/SQDCDisplayNameHelper";

const props = defineProps({
  filter: {
    type: Object as PropType<IDFilter>,
    required: true,
  },
  mode: {
    type: Number as PropType<FilterEntity>,
    required: true,
  },
  ...FilterBadgeProps,
});
const { t } = useTranslation();
const displayName = useSQDCDisplayName();
const boardFilterOptions = inject(BoardFilterOptionsInjectionKey);

onMounted(() => {
  if (props.filter.ids.length > 0) void boardFilterOptions?.load();
});

const typeNames = computed(
  () => new Map(props.types.map((type) => [type.id.toString(), displayName(type)])),
);
const sortedIDs = computed(() => [...props.filter.ids].sort((left, right) => right - left));
const displayedIDs = computed(() => {
  const options = boardFilterOptions?.options.value;
  const ids = props.mode === FilterEntity.EVENT ? options?.eventIds : options?.actionIds;
  const labels = new Map(ids?.map((option) => [option.value, option.label]));
  return sortedIDs.value.map((id) => labels.get(id) ?? String(id));
});

function getTypeFieldName() {
  const name =
    props.filter.typeId == null ? undefined : typeNames.value.get(props.filter.typeId.toString());

  return name ?? t("global.na");
}

const text = computed(() => {
  const typeText = props.filter.typeId ? getTypeFieldName() : t(`global.all`);
  return `${typeText}${displayedIDs.value.length > 0 ? " | " : ""}${displayedIDs.value.join(", ")}`;
});
</script>

<style lang="scss" scoped></style>
